<template>
  <v-dialog v-model="dialog" max-width="600px" persistent scrollable>
    <BaseBodyDialog title="Cập nhập Học phí cơ bản" @close="close" @save="save" :loading="loading">
      <v-container class="pa-0 mt-6">
        <v-form ref="form" v-model="valid">
          <p class="font-weight-black black--text">1. Thông tin lớp</p>
          <v-row dense class="mb-2">
            <v-col cols="12">
              <AutocompleteClass
                v-model="formData.class"
                label="Lớp học"
                :rules="[(v) => !!v || 'Vui lòng chọn lớp học']"
                disabled
                outlined
                hide-details
                dense
                @change="onClassChange"
              />
            </v-col>
          </v-row>
          <v-row dense class="mb-2">
            <v-col cols="12" v-if="formData.class">
              <div v-if="classTimeRange.start && classTimeRange.end" class="text-caption">
                Thời gian học: {{ formatDate(classTimeRange.start) }} - {{ formatDate(classTimeRange.end) }}
                ({{ countLesson }}
                buổi)
              </div>
              <div v-else class="text-caption mb-6">
                Lớp này chưa được xếp lịch, vui lòng xếp lịch trước khi cấu hình học phí
              </div>
            </v-col>
          </v-row>

          <p class="font-weight-black black--text">2. Mức học phí</p>
          <v-row dense>
            <v-col cols="12" v-if="isHybridMode">
              <div class="black--text">Lớp offline</div>
            </v-col>
            <v-col cols="6">
              <currency-input
                v-model="formData.amount"
                :label="amountLabel"
                prefix="VNĐ"
                dense
                :rules="[
                  (v) => !!v || 'Vui lòng nhập số tiền',
                ]"
              />
            </v-col>
            <v-col cols="6">
              <v-select
                v-model="formData.priceType"
                :items="filteredPriceTypes"
                label="Đơn vị áp dụng (tính theo)"
                item-text="text"
                item-value="value"
                :rules="[(v) => !!v || 'Vui lòng chọn đơn vị áp dụng']"
                outlined
                dense
              />
            </v-col>
            <v-col cols="12" v-if="isHybridMode">
              <span class="black--text">Lớp online</span>
            </v-col>
            <v-col cols="6" v-if="isHybridMode">
              <currency-input
                v-model="formData.onlineAmount"
                :label="amountLabel"
                prefix="VNĐ"
                dense
                :rules="[
                  (v) => !!v || 'Vui lòng nhập số tiền',
                ]"
              />
            </v-col>
            <v-col cols="6" v-if="isHybridMode">
              <v-select
                v-model="formData.priceType"
                :items="filteredPriceTypes"
                label="Đơn vị áp dụng (tính theo)"
                item-text="text"
                item-value="value"
                :rules="[(v) => !!v || 'Vui lòng chọn đơn vị áp dụng']"
                outlined
                dense
              />
            </v-col>
          </v-row>

          <p class="font-weight-black black--text">3. Phương thức thu</p>
          <v-row dense>
            <v-col cols="6">
              <v-select
                v-model="formData.paymentType"
                :items="filteredPaymentTypes"
                label="Hình thức thu"
                item-text="text"
                item-value="value"
                :rules="[(v) => !!v || 'Vui lòng chọn hình thức thu']"
                outlined
                dense
              />
            </v-col>
            <v-col cols="6">
              <v-select
                v-if="formData.priceType !== 'course'"
                v-model.number="formData.periodic"
                :items="periodicSelect"
                label="Định kỳ"
                item-text="text"
                item-value="value"
                :rules="[(v) => !!v || 'Vui lòng chọn định kỳ']"
                outlined
                dense
              />
            </v-col>
          </v-row>

          <template v-if="isHybridMode">
            <v-row dense v-if="formData.priceType === 'course' && formData.paymentType">
              <v-col cols="12" class="black--text">Đợt 1</v-col>
              <v-col cols="6">
                <currency-input
                  v-model="formData.firstPaymentAmount"
                  label="Offline"
                  prefix="VNĐ"
                  dense
                  :rules="[
                  (v) => !!v || 'Vui lòng nhập số tiền',
                ]"
                />
              </v-col>
              <v-col cols="6">
                <v-select
                  v-model="formData.collectionTime1"
                  :items="[{ text: 'Bắt đầu khoá học', value: 'start' }]"
                  label="Thời điểm thu"
                  item-text="text"
                  item-value="value"
                  :rules="[(v) => !!v || 'Vui lòng chọn thời điểm thu']"
                  outlined
                  dense
                />
              </v-col>
              <v-col cols="6">
                <currency-input
                  v-model="formData.onlineFirstPaymentAmount"
                  label="Online"
                  prefix="VNĐ"
                  dense
                  :rules="[
                  (v) => !!v || 'Vui lòng nhập số tiền',
                ]"
                />
              </v-col>
              <v-col cols="6">
                <v-select
                  v-model="formData.collectionTime1"
                  :items="[{ text: 'Bắt đầu khoá học', value: 'start' }]"
                  label="Thời điểm thu"
                  item-text="text"
                  item-value="value"
                  :rules="[(v) => !!v || 'Vui lòng chọn thời điểm thu']"
                  outlined
                  dense
                />
              </v-col>
            </v-row>
            <v-row dense v-if="formData.priceType === 'course' && formData.paymentType === 'pre_many'">
              <v-col cols="12" class="black--text">Đợt 2</v-col>
              <v-col cols="6">
                <currency-input
                  v-model="formData.secondPaymentAmount"
                  label="Offline"
                  prefix="VNĐ"
                  dense
                  :rules="[
                  (v) => !!v || 'Vui lòng nhập số tiền',
                ]"
                />
              </v-col>
              <v-col cols="6">
                <v-select
                  v-model="formData.collectionTime2"
                  :items="[{ text: 'Sau 1 tháng', value: 'afterOneMonth' }]"
                  label="Thời điểm thu"
                  item-text="text"
                  item-value="value"
                  :rules="[(v) => !!v || 'Vui lòng chọn thời điểm thu']"
                  outlined
                  dense
                />
              </v-col>
              <v-col cols="6">
                <currency-input
                  v-model="formData.onlineSecondPaymentAmount"
                  label="Online"
                  prefix="VNĐ"
                  dense
                  :rules="[
                  (v) => !!v || 'Vui lòng nhập số tiền',
                ]"
                />
              </v-col>
              <v-col cols="6">
                <v-select
                  v-model="formData.collectionTime2"
                  :items="[{ text: 'Sau 1 tháng', value: 'afterOneMonth' }]"
                  label="Thời điểm thu"
                  item-text="text"
                  item-value="value"
                  :rules="[(v) => !!v || 'Vui lòng chọn thời điểm thu']"
                  outlined
                  dense
                />
              </v-col>
            </v-row>
          </template>
          <template v-else>
            <v-row dense v-if="formData.priceType === 'course' && formData.paymentType">
              <v-col cols="6">
                <currency-input
                  v-model="formData.firstPaymentAmount"
                  label="Đợt 1"
                  prefix="VNĐ"
                  dense
                  :rules="[
                  (v) => !!v || 'Vui lòng nhập số tiền',
                ]"
                />
              </v-col>
              <v-col cols="6">
                <v-select
                  v-model="formData.collectionTime1"
                  :items="[{ text: 'Bắt đầu khoá học', value: 'start' }]"
                  label="Thời điểm thu"
                  item-text="text"
                  item-value="value"
                  :rules="[(v) => !!v || 'Vui lòng chọn thời điểm thu']"
                  outlined
                  dense
                />
              </v-col>
            </v-row>
            <v-row dense v-if="formData.priceType === 'course' && formData.paymentType === 'pre_many'">
              <v-col cols="6">
                <currency-input
                  v-model="formData.secondPaymentAmount"
                  label="Đợt 2"
                  prefix="VNĐ"
                  dense
                  :rules="[
                  (v) => !!v || 'Vui lòng nhập số tiền',
                ]"
                />
              </v-col>
              <v-col cols="6">
                <v-select
                  v-model="formData.collectionTime2"
                  :items="[{ text: 'Sau 1 tháng', value: 'afterOneMonth' }]"
                  label="Thời điểm thu"
                  item-text="text"
                  item-value="value"
                  :rules="[(v) => !!v || 'Vui lòng chọn thời điểm thu']"
                  outlined
                  dense
                />
              </v-col>
            </v-row>
          </template>

          <p class="font-weight-black black--text">4. Cài đặt thêm</p>
          <v-row dense>
            <v-col cols="12">
              <v-checkbox class="pa-0 ma-0" label="Yêu cầu đặt cọc" hide-details disabled></v-checkbox>
            </v-col>
            <v-col cols="12">
              <v-checkbox
                class="pa-0 ma-0"
                label="Điều chỉnh học phí theo số buổi học thực tế"
                v-model="formData.isActual"
                hide-details
                :disabled="isHybridMode || formData.paymentType !== 'post_actual'">
              </v-checkbox>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </BaseBodyDialog>
  </v-dialog>
</template>

<script>
import AutocompleteClass from '@/components/basic/input/AutocompleteClass'
import BaseBodyDialog from '@/components/basic/dialog/BaseBodyDialog'
import CurrencyInput from '@/components/basic/input/CurrencyInput.vue'
import { mask } from 'vue-the-mask'
import { mapActions } from 'vuex'
import moment from 'moment'
import { toNumber, get } from 'lodash-es'

export default {
  name: 'DialogEditClassSetup',
  components: {
    AutocompleteClass,
    BaseBodyDialog,
    CurrencyInput,
  },
  props: {
    isOpen: Boolean,
  },
  directives: {
    mask
  },
  data() {
    return {
      dialog: false,
      valid: false,
      loading: false,
      formData: {
        id: null,
        class: null,
        priceType: null,
        paymentType: null,
        amount: null,
        periodic: null,
        isActual: null,
        onlineAmount: null,
        firstPaymentAmount: null,
        onlineFirstPaymentAmount: null,
        secondPaymentAmount: null,
        onlineSecondPaymentAmount: null,
        collectionTime1: null,
        collectionTime2: null,
      },
      priceTypes: [
        { text: 'Cho mỗi buổi học', value: 'per_session' },
        { text: 'Cho mỗi tháng học', value: 'monthly' },
        // { text: 'Theo 3 tháng', value: 'quarterly' },
        { text: 'Cho cả khoá', value: 'course' }
      ],
      paymentTypes: [
        { text: 'Thu trước (đầu kỳ)', value: 'pre' },
        { text: 'Thu sau (cuối kỳ)', value: 'post_actual' },
        // { text: 'Thu sau (theo dự kiến)', value: 'post_expected' },
        { text: 'Thu trước (1 đợt)', value: 'pre_one' },
        { text: 'Thu trước (nhiều đợt)', value: 'pre_many' }
      ],
      periodicSelect: [
        { text: 'Theo mỗi tháng', value: 1 },
        { text: '2 tháng 1 lần', value: 2 },
        { text: '3 tháng 1 lần', value: 3 }
      ],
      classTimeRange: {
        start: null,
        end: null
      },
      countLesson: 0
    }
  },

  computed: {
    amountLabel() {
      const priceType = this.priceTypes.find((type) => type.value === this.formData.priceType)
      if (!priceType) return 'Số tiền (VND)'
      return `Số tiền (VND) / ${priceType.text.toLowerCase()}`
    },
    filteredPriceTypes() {
      if (this.isHybridMode) {
        return this.priceTypes.filter((type) => ['per_session', 'course'].includes(type.value))
      }
      return this.priceTypes
    },
    filteredPaymentTypes() {
      if (this.isHybridMode) {
        switch (this.formData.priceType) {
          case 'per_session':
            return this.paymentTypes.filter((type) => type.value === 'post_actual')
          case 'course':
            return this.paymentTypes.filter((type) => ['pre_one', 'pre_many'].includes(type.value))
          default:
            return []
        }
      }

      switch (this.formData.priceType) {
        case 'per_session':
        case 'monthly':
          return this.paymentTypes.filter((type) => ['pre', 'post_actual'].includes(type.value))
        case 'quarterly':
          return this.paymentTypes.filter((type) => ['pre', 'post_expected'].includes(type.value))
        case 'course':
          return this.paymentTypes.filter((type) => ['pre_one', 'pre_many'].includes(type.value))
        default:
          return []
      }
    },
    isHybridMode() {
      return get(this.formData, 'class.metadata.classMode') === 'hybrid'
    }
  },

  watch: {
    'formData.priceType'() {
      if (this.isHybridMode) {
        this.formData.isActual = this.formData.priceType === 'per_session'
      }
      // this.formData.paymentType = null
    },
    'formData.paymentType'() {
      if (this.formData.paymentType !== 'post_actual') {
        this.formData.isActual = false
      }
    }
  },

  methods: {
    ...mapActions('lesson', ['fetchLessons']),
    ...mapActions('tuitionFeeClassSetup', ['update']),

    formatDate(date) {
      return moment(date).format('DD/MM/YYYY')
    },

    async onClassChange(classData) {
      if (!classData) {
        this.classTimeRange = {
          start: null,
          end: null
        }
        return
      }

      try {
        let lessons = await this.fetchLessons({
          class: classData.id
        })
        lessons = lessons.sort((a, b) => a.index - b.index)
        if (lessons && lessons.length > 0) {
          this.classTimeRange = {
            start: lessons[0].date,
            end: lessons[lessons.length - 1].date
          }
          this.countLesson = lessons.length
        } else {
          this.classTimeRange = {
            start: null,
            end: null
          }
          this.countLesson = 0
        }
      } catch (error) {
        console.error('Error fetching lessons:', error)
      }
    },

    openDialog(item, isHybrid = false) {
      this.dialog = true
      this.isHybrid = isHybrid
      this.formData.id = item.id
      this.formData.class = item.class
      this.formData.priceType = item.priceType
      this.formData.paymentType = item.paymentType
      this.formData.amount = item.amount
      this.formData.periodic = get(item, 'metadata.periodic')
      this.formData.isActual = get(item, 'metadata.isActual')
      this.formData.onlineAmount = get(item, 'metadata.onlineAmount')
      this.formData.firstPaymentAmount = get(item, 'metadata.firstPaymentAmount')
      this.formData.secondPaymentAmount = get(item, 'metadata.secondPaymentAmount')
      this.formData.collectionTime1 = get(item, 'metadata.collectionTime1')
      this.formData.collectionTime2 = get(item, 'metadata.collectionTime2')

      this.onClassChange(this.formData.class)
    },

    close() {
      this.dialog = false
      this.$refs.form.reset()
      this.classTimeRange = {
        start: null,
        end: null
      }
    },

    save() {
      if (this.$refs.form.validate()) {
        if (!this.classTimeRange.start || !this.classTimeRange.end) {
          return
        }
        // Format amount to number before saving
        const amount = toNumber(this.formData.amount)
        const payload = {
          ...this.formData,
          classId: this.formData.class.id,
          amount,
          classTimeRange: this.classTimeRange,
          onlineAmount: this.formData.onlineAmount,
          periodic: ['pre', 'post_actual'].includes(this.formData.paymentType) ? this.formData.periodic : null,
          isActual: this.formData.isActual
        }

        if (this.formData.onlineAmount) {
          payload.onlineAmount = toNumber(this.formData.onlineAmount)
        }

        if (this.formData.firstPaymentAmount) {
          payload.firstPaymentAmount = toNumber(this.formData.firstPaymentAmount)
        }

        if (this.formData.secondPaymentAmount) {
          payload.secondPaymentAmount = toNumber(this.formData.secondPaymentAmount)
        }

        this.update({ id: this.formData.id, params: payload })
        this.close()
      }
    }
  }
}
</script>
